import React from "react";
import classes from "./NotificationSection.module.css";
import { NoNotificationFoundIcon } from "../../constant";
import NotificationList from "../NotificationList";
import SpinLoader from "../SpinLoader";
const NoNotificationFound = ({}) => {
  return (
    <div className={classes.noNotificationFound}>
      <figure>
        <NoNotificationFoundIcon />
      </figure>
      <div>
        <h2 className={classes.noNotificationTitle}>
          You have no notifications!
        </h2>
        <p className={classes.noNotificationDescription}>
          No notifications found
        </p>
      </div>
    </div>
  );
};

const NotificationSection = ({ data, loading }) => {
  console.log("loading", loading);
  let notificationList = <NoNotificationFound />;
  if (data && data?.length > 0) {
    notificationList = data?.map((notification) => (
      <>
        <NotificationList notification={notification} />
      </>
    ));
  }

  return (
    <>
      <div className={classes.wrapper}>
        <h2 className={classes.title}>Notifications</h2>
        {/* <NoNotificationFound /> */}
        {loading ? <SpinLoader /> : <>{notificationList}</>}
      </div>
    </>
  );
};

export default NotificationSection;
